import { setTheme } from "theme/default/setTheme";

export const setBorderRadius_15px = setTheme(({ theme }) => `border-radius: ${theme.borderRadius.border_radius_15px}`);
